import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import i18next from "i18next";

import "./footer.css";

const Footer = () => {
  const { t } = useTranslation(["footer"]);
  const lang = (i18next.language || "en").slice(0, 2);
  return (
    <footer className="spk_footer">
      <div className="spk_footer_inner">
        <div className="spk_footer_brand">
          <strong>SocialPika</strong>
          <span>{t("tagline", { defaultValue: "Plan, publish and grow on every network." })}</span>
        </div>
        <nav className="spk_footer_links">
          <Link to="/news">{t("news")}</Link>
          <Link to="/news">{t("vote")}</Link>
          <a href="https://www.socialpika.com/docs" target="_blank" rel="noreferrer noopener">{t("help", { defaultValue: "Help" })}</a>
          <a href="mailto:support@socialpika.com">{t("contact", { defaultValue: "Contact" })}</a>
          <a href="https://www.socialpika.com/terms" target="_blank" rel="noreferrer noopener">{t("terms", { defaultValue: "Terms" })}</a>
          <a href="https://www.socialpika.com/privacy" target="_blank" rel="noreferrer noopener">{t("privacy", { defaultValue: "Privacy" })}</a>
        </nav>
        <div className="spk_footer_end">
          <span className="spk_footer_lang">
            <button type="button" className={lang === "en" ? "on" : ""} onClick={() => i18next.changeLanguage("en")}>EN</button>
            <button type="button" className={lang === "fr" ? "on" : ""} onClick={() => i18next.changeLanguage("fr")}>FR</button>
          </span>
          <span>© {new Date().getFullYear()} SocialPika</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
